import { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';

import { socket } from 'api';
import { notify } from 'libs/common';
import { Content, AlarmButton } from './alert-button.styled';

const BellIcon = () => (
  <svg width="17" height="17" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden>
    <path d="M18 8A6 6 0 0 0 6 8c0 7-3 9-3 9h18s-3-2-3-9" />
    <path d="M13.73 21a2 2 0 0 1-3.46 0" />
  </svg>
);

export const AlertButton = (props) => {
  const { t } = useTranslation();
  const [enabled, setEnabled] = useState(false);
  const rightSetStatus = window.haveRight('racks.fire_alarm');

  useEffect(() => {
    socket.on('racks.get_fire_alarm', (msg) => {
      setEnabled(msg.enable);
    });
    socket.call('racks.get_fire_alarm');

    return () => {
      socket.off('racks.get_fire_alarm');
    };
  }, []);

  const toggleFireAlert = () => {
    socket.call('racks.set_fire_alarm', { enable: !enabled });
    notify(t('widgets.Пожарная тревога'), t('widgets.Тревога отключена'), 'danger');
  };

  const showAlertPopup = () => {
    props.openWindow({
      id: 'AlertConfirmModal',
      type: 'alert_enable',
      data: {},
      header: t('widgets.Пожарная тревога'),
    });
  };

  if (!rightSetStatus) {
    return null;
  }

  return (
    <Content>
      <AlarmButton className={enabled ? 'active' : ''} onClick={!enabled ? showAlertPopup : toggleFireAlert}>
        <BellIcon />
        {!enabled ? t('widgets.Включить тревогу') : t('widgets.Отключить тревогу')}
      </AlarmButton>
    </Content>
  );
};
